<template>
  <section>
    <div class="modal fade" id="pwd_modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
            <h4 class="modal-title">Change Password</h4>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">Old Password</label>
                  <div class="col-sm-9">
                    <input type="password" class="form-control" name="old_password" v-model="pwd.old_password" placeholder="Old Password" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="path_name" class="col-sm-3 control-label">New Password</label>
                  <div class="col-sm-9">
                    <input type="password" class="form-control" name="new_password" v-model="pwd.new_password" placeholder="New Password" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="path_name" class="col-sm-3 control-label">Confirm Password</label>
                  <div class="col-sm-9">
                    <input type="password" class="form-control" name="new_password_re" placeholder="Confirm Password" />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="saveForm">Save</button>
          </div>
        </div>
      </div>
    </div>

    <!-- left side start-->
    <div class="left-side sticky-left-side">
      <!--logo and iconic logo start-->
      <div class="logo">
        <a href="#"> Backend Management System </a>
      </div>

      <div class="logo-icon text-center">
        <a href="index.html"><img src="images/logo_icon.png" alt="" /></a>
      </div>
      <!--logo and iconic logo end-->

      <div class="left-side-inner">
        <!-- visible to small devices only -->
        <div class="visible-xs hidden-sm hidden-md hidden-lg">
          <div class="media logged-user">
            <img alt="" src="images/photos/user-avatar.png" class="media-object" />
            <div class="media-body">
              <h4>
                <a href="#">{{ name }}</a>
              </h4>
              <span>"Hello There..."</span>
            </div>
          </div>

          <h5 class="left-nav-title">Account Information</h5>
          <ul class="nav nav-pills nav-stacked custom-nav">
            <li>
              <a href="#" @click="change_password()"><i class="fa fa-cog"></i> <span>Change Password</span></a>
            </li>
            <li>
              <a href="#" @click="logout()"><i class="fa fa-sign-out"></i> <span>Sign Out</span></a>
            </li>
          </ul>
        </div>

        <!--sidebar nav start-->
        <ul class="nav nav-pills nav-stacked custom-nav" v-if="menus">
          <li :class="path == '/' ? 'active' : ''">
            <a href="/"><i class="fa fa-home"></i> <span>Home</span></a>
          </li>
          <li :class="[nav_active(menu.id) ? 'nav-active' : '', 'menu-list']" v-for="menu in menus[0]">
            <a href="javascript:;"
              ><i :class="[menu.icon, 'fa']"></i> <span>{{ menu.name }}</span></a
            >
            <ul class="sub-menu-list" v-if="menus[menu.id] != null && menus[menu.id].length > 0">
              <li v-for="s in menus[menu.id]" :class="path == s.path ? 'active' : ''">
                <a :href="'/#' + s.path"> {{ s.name }} </a>
              </li>
            </ul>
          </li>
        </ul>
        <!--sidebar nav end-->
      </div>
      <!-- left side end-->
    </div>
    <!-- main content start-->
    <div class="main-content">
      <!-- header section start-->
      <div class="header-section">
        <!--toggle button start-->
        <a class="toggle-btn"><i class="fa fa-bars"></i></a>
        <!--toggle button end-->

        <!--search start-->
        <form class="searchform" onsubmit="return false">
          <input type="text" class="form-control" name="keyword" placeholder="Search here..." />
        </form>
        <!--search end-->

        <!--notification menu start -->
        <div class="menu-right" style="display: flex;align-items: center">
          <!--<a href="/#/notice/notice_list">-->
          <!--  <div style="margin-bottom: 10px;display: inline-block;width: 26px;cursor: pointer">-->
          <!--  <el-badge :value="12" class="item" :max="50">-->
          <!--    <i class="fa fa-bell-o"></i>-->
          <!--  </el-badge>-->
          <!--  </div>-->
          <!--</a>-->
          <ul class="notification-menu" style="padding-left: 10px;">
            <li>
              <a href="#" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
                <img src="images/photos/user-avatar.png" alt="" />
                {{ name }}
                <span class="caret"></span>
              </a>
              <ul class="dropdown-menu dropdown-menu-usermenu pull-right">
                <li>
                  <a href="#" @click="change_password()"><i class="fa fa-cog"></i> Change Password</a>
                </li>
                <li>
                  <a href="#" @click="logout()"><i class="fa fa-sign-out"></i> Log Out</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <!--notification menu end -->
      </div>
      <!-- header section end-->

      <!-- page heading start-->
      <div class="page-heading">
        <h3>
          {{ menu.name }}
        </h3>
      </div>
      <!-- page heading end-->

      <!--body wrapper start-->
      <div class="wrapper">
        <router-view />
      </div>
      <!--body wrapper end-->

      <!--footer section start-->
      <footer
        style="
          z-index: 999;
          position: fixed;
          bottom: 0;
          left: 240;
          _position: absolute;
          _top: expression_r(documentElement.scrollTop + documentElement.clientHeight-this.offsetHeight);
          overflow: visible;
        "
      >
        2018 &copy; WNR
      </footer>
      <!--footer section end-->
    </div>
    <!-- main content end-->
  </section>
</template>

<script>
import Session from "@/session";
export default {
  name: "Home",
  mounted: function () {
    var that = this;
    this.$axios.get("/info").then(function (res) {
      if (res.errorCode == 0) {
        Session.user = res.value.user;
        Session.site = Session[res.value.site];
        that.user = res.value.user;
        var map = {};
        var permissions = [];
        for (var i = 0, len = that.user.menus.length; i < len; i++) {
          var m = that.user.menus[i];
          if (["WNR Review", "Amazon Review"].includes(m.name)) continue;
          if (m.name == "Social Review") m.name = "Video";
          if (map[m.pid]) {
            map[m.pid].push(m);
          } else {
            map[m.pid] = [m];
          }

          //
          if (m.path) {
            permissions.push(m.path);
          }
          if (m.actions) {
            for (var j = 0; j < m.actions.length; j++) {
              permissions.push(m.actions[j].path);
            }
          }
        }
        that.$store.commit("permissions", permissions);
        that.times = 1;
        that.menus = map;
      }
    });

    $("#pwd_modal form")
      .bootstrapValidator({
        message: "输入不合法",
        fields: {
          old_password: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 6,
                max: 20,
              },
            },
          },
          new_password: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 6,
                max: 20,
              },
            },
          },
          new_password_re: {
            validators: {
              notEmpty: {},
              stringLength: {
                min: 6,
                max: 20,
              },
              identical: {
                field: "new_password",
              },
            },
          },
        },
      })
      .on("success.form.bv", function (e) {
        that.$axios.post("/member/changePassword", that.pwd).then(function (res) {
          layer.msg(res.message);
          if (res.errorCode == 0) {
            $("#pwd_modal").modal("hide");
          }
        });
      });
  },
  data() {
    return {
      menu: {},
      user: {},
      menus: {},
      times: 0,
      pwd: { old_password: "", new_password: "" },
    };
  },
  computed: {
    path() {
      return this.$store.state.path;
    },
    name() {
      return this.user.realname || this.user.username;
    },
  },
  methods: {
    setMenu: function (menu) {
      this.menu = menu;
    },
    change_password: function () {
      this.pwd = { old_password: "", new_password: "" };
      $("#pwd_modal").modal("show");
    },
    logout: function () {
      var that = this;
      this.$axios.post("/logout").then(function (res) {
        if (res.errorCode == 0) {
          that.$store.commit("logout");
          location.href = "login.html";
        }
      });
    },
    nav_active: function (id) {
      var sub_m = this.menus[id];
      if (sub_m != null && sub_m.length > 0) {
        for (var i = 0; i < sub_m.length; i++) {
          if (sub_m[i].path == this.path) {
            return true;
          }
        }
      }
      return false;
    },
    initCurrentMenu: function () {
      outer: for (var i = 0; i < this.menus[0].length; i++) {
        if (this.menus[this.menus[0][i].id])
          for (var j = 0; j < this.menus[this.menus[0][i].id].length; j++) {
            var s = this.menus[this.menus[0][i].id][j];
            if (s.path == this.path) {
              //this.$emit('current',s);
              this.menu = s;
              break outer;
            }
          }
      }
    },
  },
  watch: {
    $route: function (to, from) {
      if (Object.keys(this.menus).length > 0) this.initCurrentMenu();
    },
  },
  updated: function () {
    //只执行一次
    if (this.times == 1) {
      this.times++;
      (function () {
        "use strict";
        // custom scrollbar

        $("html").niceScroll({
          styler: "fb",
          cursorcolor: "#65cea7",
          cursorwidth: "6",
          cursorborderradius: "0px",
          background: "#424f63",
          spacebarenabled: false,
          cursorborder: "0",
          zindex: "1000",
        });

        $(".left-side").niceScroll({
          styler: "fb",
          cursorcolor: "#65cea7",
          cursorwidth: "3",
          cursorborderradius: "0px",
          background: "#424f63",
          spacebarenabled: false,
          cursorborder: "0",
        });

        $(".left-side").getNiceScroll();
        if ($("body").hasClass("left-side-collapsed")) {
          $(".left-side").getNiceScroll().hide();
        }

        // Toggle Left Menu
        jQuery(".menu-list > a").click(function () {
          var parent = jQuery(this).parent();
          var sub = parent.find("> ul");

          if (!jQuery("body").hasClass("left-side-collapsed")) {
            if (sub.is(":visible")) {
              sub.slideUp(200, function () {
                parent.removeClass("nav-active");
                // jQuery(".main-content").css({ height: "" });
                mainContentHeightAdjust();
              });
            } else {
              visibleSubMenuClose();
              parent.addClass("nav-active");
              sub.slideDown(200, function () {
                mainContentHeightAdjust();
              });
            }
          }
          return false;
        });

        function visibleSubMenuClose() {
          jQuery(".menu-list").each(function () {
            var t = jQuery(this);
            if (t.hasClass("nav-active")) {
              t.find("> ul").slideUp(200, function () {
                t.removeClass("nav-active");
              });
            }
          });
        }

        function mainContentHeightAdjust() {
          // Adjust main content height
          /*
						 var docHeight = jQuery(document).height();
						 console.log(docHeight)
						 if(docHeight > jQuery('.main-content').height())
						 jQuery('.main-content').height(docHeight);
						 */

          var docHeight = jQuery(document).height();
          // docHeight = docHeight - 51;
          // jQuery(".main-content").css("min-height", docHeight - 55);
          // jQuery(".main-content").css("min-height", calc(100vh - 10px));
          /*
						 if(docHeight > jQuery('.main-content').height())
						 jQuery('.main-content').css('min-height',docHeight);
						 */
        }

        mainContentHeightAdjust();

        //  class add mouse hover
        jQuery(".custom-nav > li").hover(
          function () {
            jQuery(this).addClass("nav-hover");
          },
          function () {
            jQuery(this).removeClass("nav-hover");
          }
        );

        // Menu Toggle
        jQuery(".toggle-btn").click(function () {
          $(".left-side").getNiceScroll().hide();

          if ($("body").hasClass("left-side-collapsed")) {
            $(".left-side").getNiceScroll().hide();
          }
          var body = jQuery("body");
          var bodyposition = body.css("position");

          if (bodyposition != "relative") {
            if (!body.hasClass("left-side-collapsed")) {
              body.addClass("left-side-collapsed");
              jQuery(".custom-nav ul").attr("style", "");

              jQuery(this).addClass("menu-collapsed");
              document.cookie = "m_collapsed" + "=" + "1" + (";path=" + "/") + ";expires=" + 360 * 24 * 60 * 60 * 1000;
            } else {
              body.removeClass("left-side-collapsed chat-view");
              jQuery(".custom-nav li.active ul").css({ display: "block" });

              jQuery(this).removeClass("menu-collapsed");
              document.cookie = "m_collapsed" + "=" + "1" + ";path=/;expires=" + new Date(new Date().getTime() - 1).toGMTString();
            }
          } else {
            if (body.hasClass("left-side-show")) {
              body.removeClass("left-side-show");
            } else {
              body.addClass("left-side-show");
            }

            mainContentHeightAdjust();
          }
        });

        searchform_reposition();

        jQuery(window).resize(function () {
          if (jQuery("body").css("position") == "relative") {
            jQuery("body").removeClass("left-side-collapsed");
          } else {
            jQuery("body").css({ left: "", marginRight: "" });
          }

          searchform_reposition();
        });

        function searchform_reposition() {
          if (jQuery(".searchform").css("position") == "relative") {
            jQuery(".searchform").insertBefore(".left-side-inner .logged-user");
          } else {
            jQuery(".searchform").insertBefore(".menu-right");
          }
        }

        var menu_data = [];
        $("ul.sub-menu-list li").each(function () {
          menu_data.push({ id: $(this).attr("id"), name: $(this).find("a").text(), url: $(this).find("a").attr("href") });
        });

        $("form.searchform input").autocomplete({
          minLength: 0,
          source: function (req, res) {
            if (menu_data.length > 0) {
              var m_list = [];
              for (var i = 0; i < menu_data.length; i++) {
                if (m_list.length > 15) break;
                if (menu_data[i].name.toLowerCase().indexOf(req.term.trim().toLowerCase()) != -1) {
                  m_list.push(menu_data[i]);
                }
              }
              if (m_list.length == 0) {
                res([{ label: "Not Found The Menu", value: "", data: null }]);
              } else {
                res(
                  $.map(m_list, function (item) {
                    return {
                      label: item.name,
                      value: item.name,
                      data: item,
                    };
                  })
                );
              }
            }
          },
          select: function (e, ui) {
            if (ui.item.value == "") {
              return false;
            }
            location.href = ui.item.data.url;
          },
        });
      })(jQuery);
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/main/Home.vue